import(/* webpackMode: "eager" */ "/home/runner/_work/nbit-branch-back-office/nbit-branch-back-office/src/app/task-management/page.tsx");
